import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const VenueList = (props: PickerListProps<server.dto.VenueSmall>) => {
  const [instruction, setInstruction] = React.useState<server.dto.ListVenueInstruction>({
    page: 1,
    perPage: 20,
    keyword: "",
  });

  return <>
    <PickerList
      instruction={instruction}
      onInstructionChange={setInstruction}
      queryKey="venuelist"
      api={window.CoreApi.Venue.PaginatedSmall}
      onItemSelected={props.onItemSelected}
      getError={() => undefined}
      excludeKeys={props.excludeKeys}
      getId={venue => venue.venueId}
      renderListItem={venue => <>
        <div>{venue.name}</div>
        <SubLabel>{venue.cityCountry}</SubLabel>
      </>}
    />
  </>;
};

export default VenueList;